// initial state
const state = {
  getPayType: null,
}

// mutations
const mutations = {
  savePayType(state, value) {
    state.getPayType = value;
  },
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/checkout.js